import { Status } from '@/components/common/Status'
import { AlertCircleIcon } from '@/components/common/icons'

type ErrorCardProps = {
  onRetry: () => void
}

/**
 * Shown when `useAccounts()` errors: network/timeout/5xx, and also a 401
 * whose `signinRedirect()` was suppressed by the redirect loop guard
 * (re-auth just succeeded yet the API still rejects the token — redirecting
 * again would loop). Retry is manual on purpose: an automatic one would
 * hammer a backend that has already said no.
 */
export function ErrorCard({ onRetry }: ErrorCardProps) {
  return (
    <Status
      tone="bad"
      alert
      icon={<AlertCircleIcon />}
      title={<>Couldn&rsquo;t load your workspaces.</>}
      actions={
        <button type="button" className="btn" onClick={onRetry}>
          Try again
        </button>
      }
    >
      Something went wrong on our side. Please try again in a moment.
    </Status>
  )
}
